import makeApiRequest from "./makeApiCall";

export const getRevisionHistory = async (form) => {
  return await makeApiRequest(`/revision/history`, "GET", null, form);
};
